// @ts-nocheck
import { gql } from "@apollo/client";
import * as Types from "../../../__generated__/schema.graphql.types";
import { UserMedspaConfigFragmentDoc } from "../../fragments/userMedspaConfig.graphql.types";

export type AppointmentServiceProviderBasicInfoFragment = {
  __typename?: "AppointmentService";
  provider?: {
    __typename?: "userMedspa";
    id: string;
    color?: string | null;
    initials?: string | null;
    user: {
      __typename?: "user";
      id: string;
      firstName: string;
      lastName: string;
    };
  } | null;
};

export const AppointmentServiceProviderBasicInfoFragmentDoc = gql`
  fragment AppointmentServiceProviderBasicInfo on AppointmentService {
    provider {
      id
      user {
        id
        firstName
        lastName
      }
      ...UserMedspaConfig
    }
  }
  ${UserMedspaConfigFragmentDoc}
`;
